import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { PositionComparisonSummary } from '../../../../types/generatedTypes';

interface SummaryChipsProps {
  summary: PositionComparisonSummary;
}

export const SummaryChips: React.FC<SummaryChipsProps> = ({ summary }) => (
  <>
    <Chip
      icon={<CheckCircleIcon />}
      label={`${summary.total} Total`}
      variant="outlined"
      size="small"
    />
    <Chip
      icon={<CheckCircleIcon />}
      label={`${summary.matched} Matched`}
      color="success"
      size="small"
    />
    {summary.missing_in_illio > 0 && (
      <Chip
        icon={<ErrorIcon />}
        label={`${summary.missing_in_illio} Missing in Illio`}
        color="error"
        size="small"
      />
    )}
    {summary.missing_in_bank > 0 && (
      <Chip
        icon={<WarningIcon />}
        label={`${summary.missing_in_bank} Missing in Bank`}
        color="warning"
        size="small"
      />
    )}
    {summary.quantity_alert > 0 && (
      <Chip
        icon={<WarningIcon />}
        label={`${summary.quantity_alert} Qty Alerts`}
        color="warning"
        size="small"
      />
    )}
    {summary.price_alert > 0 && (
      <Chip
        icon={<WarningIcon />}
        label={`${summary.price_alert} Price Alerts`}
        color="warning"
        size="small"
      />
    )}
  </>
);
